import SubmitEvent = JQuery.SubmitEvent;
import ClickEvent = JQuery.ClickEvent;
import { Goehler_Tool_REST_Client } from '@app/utils/rest-client'
import { handle_api_error } from '@app/utils/api-error'

jQuery(
	() => {
		console.debug( 'ready: Debug' )

		jQuery( '[data-action="generate-project"] form' ).on( 'submit', ( e:SubmitEvent ) => debug_generate_project( e ) )
		jQuery( '[data-action="generate-project"] .ui.dropdown' ).dropdown()

		jQuery( 'button[data-action="debug-update-roles"]' ).on( 'click', ( e: ClickEvent ) => debug_update_roles( e ) )
		jQuery( 'button[data-action="debug-delete-log"]' ).on( 'click', debug_delete_log )

        jQuery( 'button[data-action="send-completion-mails"]' ).on( 'click', debug_send_completion_mails )

        jQuery( 'button[data-action="recalculate-all-totals"]' ).on( 'click', () => void debug_recalculate_all_totals() )
	}
)

export function enable_debug() {
	gt_user_settings.enable_debug = '1'

    const debug_elements: HTMLElement[] = Array.from( document.querySelectorAll( '[data-debug]' ) )

	for ( const el of debug_elements ) {
		el.dataset.hidden = ''
	}

	for ( const el of Array.from( document.querySelectorAll( '.list-container table.ui' ) ) ) {
		el.classList.add( 'debug' )
	}
}

export function disable_debug() {
	gt_user_settings.enable_debug = '0'

    const debug_elements: HTMLElement[] = Array.from( document.querySelectorAll( '[data-debug]' ) )

	for ( const el of debug_elements ) {
		el.dataset.hidden = 'true'
	}

	for ( const el of Array.from( document.querySelectorAll( '.list-container table.ui' ) ) ) {
		el.classList.remove( 'debug' )
	}
}

export function debug_update_roles( e: ClickEvent ) {
	console.log( 'debug: update roles and caps' )

	// enable AJAX.
	e.preventDefault()

    const button: HTMLButtonElement|null = e.target as HTMLButtonElement

    if ( ! button ) {
        return
    }

	button.classList.add( 'disabled' )

	const { ajax_url, nonce } = gt_ajax_object

	const data = {
		action: 'debug_update_roles',
		nonce,
	}

	jQuery.ajax(
		{
			url: ajax_url,
			type: 'POST',
			dataType: 'json',
			data,
			cache: false
		}
	).done(
		( response ) => {
			console.log( response )

			button.classList.remove( 'disabled' )

			app.show_toast_ajax_response( 'Plugin: Rollen und Berechtigungen wurden aktualisiert' )
		}
	)
}

export function debug_generate_project( e: SubmitEvent ) {
	console.log( 'generate project' )

	// enable AJAX.
	e.preventDefault()

	const { ajax_url, nonce } = gt_ajax_object

	const form_data = jQuery( e.currentTarget ).serialize()

	const data = {
		action: 'debug_generate_project',
		form_data,
		nonce,
	}

	jQuery.ajax(
		{
			url: ajax_url,
			type: 'POST',
			dataType: 'json',
			data,
			cache: false
		}
	).done(
		( response ) => {
			console.log( response )

			if ( response.redirect ) {
				window.open( response.redirect, '_blank' )
				return
			}
		}
	)
}

export function debug_delete_log() {
	const list: HTMLElement|null = document.querySelector( '[data-list="debug-log"]' )

    if ( list ) {
        list.classList.remove( 'hidden' )
    }
}

export async function debug_send_completion_mails( e: ClickEvent ) {
    console.log( 'debug: send completion mails' )

    // enable AJAX.
    e.preventDefault();

    e.target.classList.add( 'disabled' )

    const data = await fetch_send_completion_mails()
    console.log( 'Mails gesendet?', data )
    e.target.classList.remove( 'disabled' )
}

export async function fetch_send_completion_mails() {
    const { ajax_url, post_id, nonce } = gt_ajax_object

    const data = {
        action: 'debug_send_completion_mails',
        post_id,
        nonce,
    }

    jQuery.ajax(
        {
            url: ajax_url,
            type: 'POST',
            dataType: 'json',
            data,
            cache: false
        }
    ).done(
        ( response ) => {
            console.log( response )
            return response
        }
    )
}

/**
 * Berechnet die Bereichssummen aller Projekte neu.
 *
 * Läuft stapelweise, damit auch bei vielen Projekten kein Timeout
 * entsteht, und zeigt den Fortschritt sowie die korrigierten Projekte.
 */
export async function debug_recalculate_all_totals() {
    console.log( '[REST] recalculate all totals' )

    const TASK = 'Neuberechnen aller Bereichssummen'

    const rest_client = new Goehler_Tool_REST_Client()

    const button = jQuery( '[data-action="recalculate-all-totals"]' )
    const container = jQuery( '.recalculation-progress' )
    const list = container.find( '.corrected-list' )

    button.addClass( 'loading disabled' ).prop( 'disabled', true )

    list.empty()
    container.removeAttr( 'data-hidden' )

    const limit = 25

    let offset = 0
    let total = 0
    let corrected = 0

    try {
        do {
            const response = await rest_client.post(
                'goehler-tool/v1/projects/recalculate-all-totals',
                { offset, limit }
            ) as {
                total: number,
                processed: number,
                corrected: { post_id: number, title: string, permalink: string, changed: number }[],
                duration: string
            }

            total = response.total
            offset += response.processed
            corrected += response.corrected.length

            for ( const project of response.corrected ) {
                list.append(
                    jQuery( '<li>' ).append(
                        jQuery( '<a>' )
                            .attr( 'href', project.permalink )
                            .text( `${ project.title } (${ project.changed } Bereiche)` )
                    )
                )
            }

            jQuery( '#recalculation-progress-bar' ).progress(
                {
                    total,
                    value: offset,
                    text: {
                        active: '{value} von {total} Projekten',
                        success: '{total} Projekte geprüft',
                    }
                }
            )

            if ( response.processed === 0 ) {
                break
            }
        } while ( offset < total )

        app.show_toast_ajax_response(
            corrected === 0
                ? `${ total } Projekte geprüft, alle Bereichssummen waren korrekt.`
                : `${ total } Projekte geprüft, ${ corrected } korrigiert.`
        )
    } catch ( error ) {
        handle_api_error( error, TASK )
    } finally {
        button.removeClass( 'loading disabled' ).prop( 'disabled', false )
    }
}
